module.exports = __webpack_public_path__ + "img/block-img-2.15f448cd.jpg";